<template>
  <div>
    <WebHeaderView :title="$t('menu.bank')" />
    <div class="page-content">
      <div class="addMethod">
        <div class="frm">
          <div class="title">银行名称</div>
          <van-field v-model="banktxt" placeholder="请选择银行" readonly>
            <template #right-icon>
              <van-icon name="arrow-down" @click="showbanklst = true" />
            </template>
          </van-field>
        </div>
        <div class="frm">
          <div class="title">银行卡号</div>
          <van-field v-model="bank_no" placeholder="请输入银行卡号" />
        </div>
        <div class="frm">
          <div class="title">开户网点</div>
          <van-field v-model="bank_address" placeholder="请输入开户网点" />
        </div>
        <div class="frm">
          <div class="title">支付密码</div>
          <van-field
            v-model="pay_pass"
            type="password"
            placeholder="请输入支付密码"
          />
        </div>
        <div class="frm" style="margin-top: 40px">
          <div
            class="post-btn"
            style="width: 96% !important; margin: 20px auto"
            @click="bindCard"
          >
            绑定银行卡
          </div>
        </div>
        <van-popup
          v-model="showbanklst"
          position="bottom"
          :style="{ height: '100vh' }"
        >
          <div
            style="
              width: calc(100vw - 20px);
              height: calc(100vh - 40px);
              background-color: #141414;
              padding: 20px 10px;
            "
          >
            <div class="select-bank-lst-header">
              <p
                style="
                  color: #fff;
                  font-size: 18px;
                  font-weight: 700;
                  margin-left: 10px;
                "
              >
                请选择开户银行
              </p>
              <div class="resarch-box">
                <van-field
                  v-model="value1"
                  placeholder="请输入银行"
                  style="border-radius: 20px; background-color: #000"
                  @input="changeTxt"
                >
                  <template #left-icon>
                    <van-icon name="search" size="24px" color="#fff" />
                  </template>
                </van-field>
              </div>
            </div>
            <div
              style="
                height: calc(100vh - 200px);
                padding: 10px;
                overflow-x: hidden;
                overflow-y: auto;
              "
            >
              <ul>
                <div v-for="(item, index) in banklist" :key="index">
                  <li
                    v-if="item.bank_name.indexOf(value1) != -1"
                    class="bank-item"
                    @click="itemClick(item, index)"
                    :style="
                      tempIndex == index
                        ? 'border-color: #D8A871;color:#D8A871;'
                        : ''
                    "
                  >
                    <img :src="item.bank_img" />{{ item.bank_name }}
                    <div class="icon" v-show="tempIndex == index">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="#D8A871"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 16.5L32 0V22C32 27.5228 27.5228 32 22 32H0L15 16.5Z"
                          fill="var(--primary-color)"
                        ></path>
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M26.2438 17.0091C26.4403 17.1401 26.5767 17.3438 26.623 17.5754C26.6693 17.807 26.6218 18.0475 26.4908 18.2441L20.5533 27.1503C20.4801 27.2598 20.3836 27.3518 20.2707 27.4195C20.1577 27.4873 20.0312 27.5292 19.9001 27.5421C19.769 27.555 19.6367 27.5388 19.5127 27.4944C19.3887 27.4501 19.276 27.3788 19.1829 27.2857L15.6204 23.7232C15.4631 23.5543 15.3774 23.331 15.3815 23.1003C15.3856 22.8696 15.479 22.6494 15.6422 22.4862C15.8054 22.3231 16.0255 22.2296 16.2563 22.2255C16.487 22.2215 16.7103 22.3071 16.8791 22.4644L19.6733 25.2586L25.0088 17.2549C25.14 17.0585 25.3438 16.9224 25.5754 16.8763C25.807 16.8302 26.0474 16.8779 26.2438 17.0091Z"
                          fill="white"
                        ></path>
                      </svg>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
            <div class="select-bank-lst-footer">
              <van-button
                style="
                  border-color: #7f7a80;
                  background-color: #141414;
                  color: #7f7a80;
                  border-radius: 8px;
                  margin-right: 5px;
                  width: 40%;
                "
                @click="showbanklst = false"
                >关闭</van-button
              >
              <van-button
                style="
                  border-color: #d8a871;
                  background-color: #d8a871;
                  color: #fff;
                  border-radius: 8px;
                  margin-left: 5px;
                  width: 40%;
                "
                @click="bankSelectOk"
                >确定</van-button
              >
            </div>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>
<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'addBankCard',
  components: { WebHeaderView },
  data () {
    return {
      baseURL: '',
      bank: null,
      banktxt: null,
      bank_owner: null,
      pay_pass: null,
      bank_no: null,
      bank_address: null,
      banklist: [],
      value1: null,
      showbanklst: false,
      tmpbanklst: [],
      tempIndex: -1,
      tmpItem: null
    }
  },
  created () {
    let that = this
    that.baseURL = sessionStorage.getItem('baseURL') || ''
    that.getBanklist()
  },
  methods: {
    bankSelectOk () {
      this.banktxt = this.tmpItem.bank_name
      this.bank = this.tmpItem.id
      this.showbanklst = false
    },
    itemClick (item, index) {
      this.tempIndex = index
      this.tmpItem = item
    },
    changeTxt () {
      this.tempIndex = -1
      this.tmpItem = null
    },
    changeShow () {
      this.tempIndex = -1
      this.value1 = null
      this.tmpItem = null
      this.showbanklst = true
    },
    changeSelect () {
      this.banklist.forEach(element => {
        if (element.id == this.bank) {
          this.banktxt = element.bank_name
        }
      })
    },
    async getBanklist () {
      await this.$http({
        method: 'post',
        url: 'SysBank'
      }).then(data => {
        this.banklist = data.data
      })
    },
    async bindCard () {
      let that = this
      if (!that.bank) {
        this.$toast.fail('请输入银行')
        return
      }
      if (!that.bank_address) {
        this.$toast.fail('请输入开户行地址')
        return
      }
      if (!that.bank_no) {
        this.$toast.fail('请输入银行卡号')
        return
      }
      if (!that.pay_pass) {
        this.$toast.fail('请输入支付密码')
        return
      }
      if (that.bank_no.length < 8) {
        this.$toast.fail('请输入正确的卡号长度')
        return
      }
      if (that.pay_pass.length < 6 || that.pay_pass.length > 18) {
        this.$toast.fail('请输入支付密码长度')
        return
      }
      let info = {
        id: that.bank,
        branch: that.bank_address,
        card_number: that.bank_no,
        pay_pass: that.pay_pass
      }

      await this.$http({
        method: 'post',
        url: 'bindCard',
        data: info
      }).then(data => {
        this.$toast.success(data.msg)
        that.$router.back()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addMethod {
  width: 94%;
  margin: 10px auto;
  text-align: left;
  .frm {
    margin: 10px 0;
    .title {
      margin-bottom: 8px;
    }
  }
}
</style>
<style scoped>
.select-bank-lst-footer {
  text-align: center;
}
li.bank-item {
  position: relative;
  border: 1px solid #7f7a80;

  border-radius: 12px;
  height: 42px;
  line-height: 42px;
  margin: 14px 0;
}
li.bank-item img {
  height: 24px;
  margin: 9px;
  float: left;
}
li.bank-item div.icon {
  position: absolute;
  right: -1px;
  bottom: -17px;
}
</style>
<style>
.addMethod .van-cell {
  background-color: #222 !important;
}
.addMethod .van-field__control {
  color: #fff !important;
}
.resarch-box {
  margin-top: 20px;
}
.resarch-box input {
  color: #fff !important;
}
</style>
